module.exports = __webpack_public_path__ + "img/scroll2.6ff80318.png";